import { useContext } from "react";
import { Link, Outlet, useNavigate } from "react-router-dom";
import { AuthContext } from "../../context/AuthContext";
import { useStore } from "../../context/StoreContext";

// TODO: change to match your real store fields
const isStoreActive = (s) => Boolean(s) && s.isActive !== false;

export default function StoreRequired() {
  const navigate = useNavigate();
  const { user } = useContext(AuthContext);
  const { selectedStore, isStoreSelected, stores } = useStore();

  const u = user?.data ?? {};
  const canManage = u.isOwner || ["owner", "admin"].includes(u.users_role);

  if (stores.length === 0) {
    return (
      <>
        <h5>
          {canManage ? "Connect your Shopify store" : "No store connected yet"}
        </h5>
        <p className="text-muted mb-3">
          {canManage
            ? "Add your store link to start syncing orders and products."
            : "Ask your workspace owner to connect a store."}
        </p>
        {canManage && (
          <button
            type="button"
            className="btn btn-success"
            onClick={() => navigate("/shopify/connect")}
          >
            Connect a Shopify store
          </button>
        )}
      </>
    );
  }

  if (!isStoreActive(selectedStore)) {
    return (
      <>
        <h5>
          {canManage ? "Connect your Shopify store" : "No store connected yet"}
        </h5>
        <p className="text-muted mb-3">
          {canManage
            ? "Add your store link to start syncing orders and products."
            : "Ask your workspace owner to connect a store."}
        </p>
      </>
    );
  }

  // 3) all good
  return <Outlet />;
}
